import React, { Component } from 'react'
import { connect } from 'react-redux'
import Progress from '../components/controls/Progress'
import InfoPanel from '../components/InfoPanel'
import WyborStruktury from '../components/Start/WyborStruktury'
import {
  licInfoExpandContent,
  licInfoRolledContent,
} from '../components/Start/ZakupLicencjiInfo'
import StartPage from '../components/StartPage'
import TypSekcji from '../components/TypSekcji'
import ZakupLicencji from '../components/ZakupLicencji/ZakupLicencji'
import Header from '../containers/Header'
import Layout from '../styles/Layout'
import Aside from './Aside'
import WalidacjaError from './WalidacjaError'
import WalidacjaSuccessDialog from './WalidacjaSuccessDialog'
import StartErrorPage from '../components/Start/StartErrorPage'
import StartPageStyle from '../styles/StartPageStyle'
import DataSporzadzenia from '../components/Start/DataSporzadzenia'

class App extends Component {
  render() {
    const {
      zakupLicencji,
      licencja,
      availableStructures,
      wyborStruktury,
      wyborDaty,
      error,
      fileName,
      sectionList,
      validityErrors,
      actualValidityError,
      czyPodsumowanie,
      czyTrwaSprawdzanie,
      czyTrwaImport,
    } = this.props
    return error ? (
      <StartPageStyle licencja={this.props.licencja}>
        <StartErrorPage />
      </StartPageStyle>
    ) : (
      !error &&
        (!fileName ? (
          wyborDaty ? (
            <DataSporzadzenia />
          ) : wyborStruktury ? (
            <WyborStruktury availableStructures={availableStructures} />
          ) : (
            <StartPage
              licencja={licencja}
              availableStructures={availableStructures}
              wyborStruktury={wyborStruktury}
              error={error}
            />
          )
        ) : zakupLicencji ? (
          <ZakupLicencji />
        ) : (
          sectionList && (
            <>
              <Progress
                isOpen={czyTrwaSprawdzanie}
                progressText="Trwa sprawdzanie poprawności e-Sprawozdania..."
                showDialog={
                  validityErrors &&
                  validityErrors.length === 0 &&
                  sectionList[0].TypSekcji !== 'Walidacja'
                }
                dialogContent={<WalidacjaSuccessDialog />}
              />
              <Progress
                isOpen={czyTrwaImport}
                progressText="Trwa import danych..."
              />
              <Layout className="main-layout">
                <div>
                  {licencja &&
                    licencja.system === 'ESPR' &&
                    licencja.status !== '0' && (
                      <InfoPanel
                        warningColor={true}
                        canExpand={true}
                        rolledContent={licInfoRolledContent(
                          licencja.status === '1',
                        )}
                        exptandContent={licInfoExpandContent(
                          licencja.status === '1',
                        )}
                      />
                    )}
                  <Header czyPodsumowanie={czyPodsumowanie} />
                </div>
                <div className="main">
                  {actualValidityError &&
                    sectionList[0].TypSekcji !== 'Walidacja' && (
                      <WalidacjaError
                        changable={true}
                        errors={validityErrors}
                        error={actualValidityError}
                      />
                    )}
                  <TypSekcji
                    sectionList={sectionList}
                    czyPodsumowanie={czyPodsumowanie}
                  />
                </div>
                {!czyPodsumowanie && <Aside />}
              </Layout>
            </>
          )
        ))
    )
  }
}

const mapStateToProps = (state) => {
  return {
    zakupLicencji: state.sprawozdanie.zakupLicencji,
    licencja: state.sprawozdanie.licencja,
    availableStructures: state.sprawozdanie.availableStructures,
    wyborStruktury: state.sprawozdanie.wyborStruktury,
    wyborDaty: state.sprawozdanie.wyborDaty,
    sectionList: state.sprawozdanie.sections,
    validityErrors: state.sprawozdanie.validityErrors,
    actualValidityError: state.sprawozdanie.actualValidityError,
    fileName: state.sprawozdanie.fileName,
    error: state.sprawozdanie.err,
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
    czyTrwaSprawdzanie: state.sprawozdanie.czyTrwaSprawdzanie,
    czyTrwaImport: state.sprawozdanie.czyTrwaImport,
  }
}

export default connect(mapStateToProps, null)(App)
